import React from "react";
import InfoStyles from "../styles/InfoStyles";
import Seo from "../seo";

const Privacy = () => {
  return (
    <>
      <Seo
        title="Privacy and Cookies Policies | Table Sage"
        description="We take data privacy seriously and would like to be transparent about what we do with the data we may collect from or about you."
        url="https://www.table-sage.com/privacy-and-cookies"
        image="https://i.imgur.com/ZfZaW5f.png"
        imageWidth="700"
        imageHeight="700"
      />
      <InfoStyles className="mt-4">
        <div className="info">
          <p className="info__header-1 mb-5">Table Sage privacy policy</p>

          <p className="info__body-text mb-5">
            We take data privacy seriously and would like to be transparent
            about what we do with the data we may collect from or about you.
            This privacy policy helps you to understand our data processing
            activities as well as your legal rights.
          </p>
          <p className="info__body-text bold-body">
            Which personal data do we gather when you visit Table Sage?
          </p>
          <p className="info__body-text">
            Table Sage collects personal data both directly (for example, when
            you sign up to receive news) and indirectly (for example, through
            our website’s technology). We may collect and process the following
            personal data:
          </p>
          <p className="info__body-text">
            • Information that you provide when compiling forms on our site;
          </p>
          <p className="info__body-text">
            • A record of any correspondence that you may initiate with us;
          </p>
          <p className="info__body-text">
            • Data about your computer, including (where available) your browser
            type, IP address, and operating system;
          </p>
          <p className="info__body-text">
            • Details of your visits to our website, including the pages you
            view and resources you access.
          </p>
          <p className="info__body-text mb-5">
            We will keep your personal data in line with the applicable laws and
            regulations. Depending on those that apply to you, you may have the
            right, amongst others, to obtain a copy of your data or request that
            we stop processing it. If you would like to exercise any of these
            rights, please contact us as per the below.
          </p>
          <p className="info__body-text bold-body">
            How do we use the personal data we gather?
          </p>
          <p className="info__body-text">
            When you provide information directly, we use it strictly to keep
            you informed of Table Sage news, or to respond to any request that
            you make.
          </p>
          <p className="info__body-text mb-5">
            When you provide information indirectly, we primarily review browser
            and IP information in order to help us to identify ways to improve
            our services.
          </p>
          <p className="info__body-text bold-body">
            Do we combine and analyze personal data?
          </p>
          <p className="info__body-text mb-5">
            At this time, we only combine and analyze personal data collected
            through our site’s analytics cookies and other tracking
            technologies. You may see our Cookies Policy below for more
            information.
          </p>
          <p className="info__body-text bold-body">
            Do we hold (links to) websites and/ or programs of third parties?
          </p>
          <p className="info__body-text">
            Our website may include links to and from the sites of our partners,
            sponsors, advertisers, and affiliates. It may also include programs
            such as the widgets and applications of third parties. Where this is
            the case, note that such third parties may process your personal
            data for their own purposes. 
          </p>
          <p className="info__body-text mb-5">
            We cannot accept responsibility for these third parties’ sites or
            programs. Please check their individual terms of use for more
            information.
          </p>
          <p className="info__body-text bold-body">
            Do we share personal data with third parties?
          </p>
          <p className="info__body-text mb-5">
            We do not share your personal data with any third parties.
          </p>
          <p className="info__body-text bold-body">
            How do we use personal data for marketing purposes?
          </p>
          <p className="info__body-text mb-5">
            At this time, we only send news updates to those who have signed up
            for them.
          </p>
          <p className="info__body-text bold-body">
            What are your rights regarding marketing communications?
          </p>
          <p className="info__body-text mb-5">
            You can inform us of your wish to be withdrawn from communications
            at any time by unsubscribing directly through our newsletters. In
            such cases, we will retain the minimum amount of personal data
            necessary in order to avoid reaching out to you in the future.
          </p>
          <p className="info__body-text bold-body">Contact us</p>
          <p className="info__body-text mb-5">
            Should you have any questions regarding our Privacy Policy, you may
            contact us at info@table-sage.com.
          </p>
          <p className="info__body-text mb-0">
            Table Sage B.V. is registered in the Netherlands, and as such,
            operates under Dutch law.
          </p>
          <p className="info__body-text mb-10">
            This Privacy Policy is effective and up to date as of June 2020.
          </p>
          <p className="info__header-1 mb-5">Table Sage cookies policy</p>
          <p className="info__body-text bold-body">
            Below is information about how Table Sage uses cookies on its
            website.
          </p>
          <p className="info__body-text mb-5">
            By continuing to use this website, you agree that we can place
            cookies and other similar technology on your device, as per your
            agreement with our cookie consent manager. When utilizing a mobile
            device to access this site, you agree that the following information
            may be collected: your unique identifier, IP address, information
            about your device’s operating system, mobile carrier, and location
            information (to the extent permissible under applicable law).
          </p>
          <p className="info__body-text bold-body">What are cookies?</p>
          <p className="info__body-text mb-5">
            Cookies are text files containing information that is downloaded to
            your computer or mobile device when visit a website. They allow a
            site to recognize your device.
          </p>
          <p className="info__body-text bold-body">
            What types of cookies are there and which ones does Table Sage use?
          </p>
          <p className="info__body-text">
            “Session” cookies are temporary and once you close the browser
            window, they are deleted from your device.
          </p>
          <p className="info__body-text">
            “Persistent” cookies remain on your device for a longer period and
            are used by the website to recognize your device when you return.
          </p>
          <p className="info__body-text mb-5">
            Table Sage uses both session and persistent cookies.
          </p>
          <p className="info__body-text bold-body">Why do we use cookies?</p>
          <p className="info__body-text mb-5">
            Cookies have several purposes. When visiting Table Sage, they allow
            you to use our mapping and sharing functionalities, and generally
            improve your user experience.
          </p>
          <p className="info__body-text bold-body">
            Do you use cookies for analytics?
          </p>
          <p className="info__body-text mb-5">
            Yes, we may use information collected from our cookies to identify
            user behavior, as to the extent legally permissible.
          </p>
          <p className="info__body-text bold-body">
            Do you use cookies from third party companies?
          </p>
          <p className="info__body-text mb-5">
            Yes, our cookies are from third party companies, including Mapbox,
            Imgur, Vimeo, Cloudinary, Facebook, Google. These
            companies use programming code to collect information about your
            interaction with our site, such as the pages you visit, the links
            you click on, and how long you visit for. This code is only active
            while you are on a Table Sage website.
          </p>
          <p className="info__body-text bold-body">
            What if I don’t want cookies?
          </p>
          <p className="info__body-text">
            By using our site, you agree that we can place cookies on your
            device as explained. Should you wish to remove existing cookies from
            your device, you may do this using your browser options. If you want
            to block future cookies from being placed on your device, you may
            change your browser settings.
          </p>
          <p className="info__body-text mb-5">
            Please bear in mind that deleting and blocking cookies will have an
            impact on your user experience, and parts of the Table Sage website
            may no longer work.
          </p>
          <p className="info__body-text bold-body">Contact us</p>
          <p className="info__body-text mb-5">
            Should you have any questions regarding our Cookies Policy, you may
            contact us at info@table-sage.com.
          </p>
          <p className="info__body-text mb-0">
            Table Sage B.V. is registered in the Netherlands, and as such,
            operates under Dutch law.
          </p>
          <p className="info__body-text">
            This Cookies Policy is effective and up to date as of June 2020.
          </p>
        </div>
      </InfoStyles>
    </>
  );
};

export default Privacy;
